import React from 'react';

import usePage from '@dashboard/hooks/usePage';

import GroupRegistrationSettingsForm, {
  CollectAttendeesSwitch,
} from './components/GroupRegistrationSettingsForm';
import GuestQuestionsForm from './components/GuestQuestionsForm';
import GuestsPreview from './GuestsPreview';

const AttendeeQuestions = () => {
  const { page } = usePage();

  return (
    <>
      <GuestsPreview page={page} />
      <CollectAttendeesSwitch />
      {page.eventDetails?.attendeeDetails?.enabled ? (
        <>
          <div className="mt-6">
            <GuestQuestionsForm />
          </div>
          <div className="mt-8 mb-3 text-sm font-semibold text-gray-900 dark:text-foreground">
            Settings
          </div>
          <GroupRegistrationSettingsForm />
        </>
      ) : null}
    </>
  );
};

export default AttendeeQuestions;
